import React from 'react';
import { LoginIllustration } from './LoginIllustration';

interface DesktopLayoutProps {
  FormComponent: React.ComponentType;
}

/**
 * Desktop auth layout (viewport width > 1023px).
 * Left half: illustration panel with the logo in its top-left corner.
 * Right half: form centred, copyright pinned to the bottom.
 */
export function DesktopLayout({ FormComponent }: DesktopLayoutProps) {
  return (
    <div className="flex overflow-hidden h-screen">
      <div className="relative h-screen w-1/2 shrink-0">
        <LoginIllustration
          className="h-full w-full"
          width="min(90.25%, 91.2vh)"
        />
        {/* Viewport units (Figma left 50 / top 50 / height 58px on 1280×832) so
            browser zoom does not resize or move the logo, matching the
            illustration */}
        <img
          src="/pozytronLogo.svg"
          alt="Pozytron"
          className="absolute left-[3.906vw] top-[6.01vh] h-[7vh] w-auto"
        />
      </div>
      {/* pt matches the footer block (40px text + 20px pb) so the form centres on the full height */}
      <div className="flex flex-col items-center justify-between z-10 pt-[60px] pb-[20px] w-1/2">
        <div className="relative flex flex-col items-start justify-center h-full">
          <FormComponent />
        </div>
        <p className="w-[360px] text-bodyMedium text-on-surface-variant text-center">
          © 2025 Pozytron Radiologia Medyczna sp. z o. o. Wszelkie prawa
          zastrzeżone.
        </p>
      </div>
    </div>
  );
}
